(() => {
  const selectedEventCategory = '.event-category-selection-js'
  const init = () => {
    $('body').on('change', selectedEventCategory, onChange);
  }
  const onChange = e => {
    e.target.form.submit();
  }
  $(init);
})();

